import React from 'react'
import { Column, Row } from './layout'
import styled from 'styled-components'
import { onMobile } from '../utils/selector'

export default function OptionalService() {
  return (
    <Container>
      <Name>可选服务</Name>
      <Item alignment="space-between">
        <Column>
          <Content>
            <li>公司注册代理人 $99.99/年</li>
          </Content>
        </Column>

        <Column>
          <Content>
            <li>公司商业收信地址代理 $300/年</li>
          </Content>
        </Column>

        <Column>
          <Content>
            <li>
              公司首年年审代理：$100
              <br />
              (不含政府申请费$20-$25)
            </li>
          </Content>
        </Column>

        <Column>
          <Content>
            <li>
              商标注册 （一个一类): $775 (含275申请费）
              <ol>
                <li>额外类别注册费: $200/个</li>
                <li>额外类别注册费: $200/个</li>
              </ol>
            </li>
          </Content>
        </Column>
      </Item>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  max-width: 918px;
`

const Item = styled(Row)`
  ${onMobile} {
    flex-direction: column;
  }

  > * {
    flex: 0.25;
  }
`

const Name = styled.strong`
  font-size: 20px;
  line-height: 28px;
  color: #005b97;
`

const Content = styled.ul`
  padding-left: 1rem;
  font-size: 14px;
  line-height: 24px;
  color: #364d6e;
  flex: 1;
`
